import React from "react";
import PropTypes from "prop-types";

import { GridRow } from "arv-reactcomponents";

import TrendingBannerComponent from "../TrendingBannerComponent";

const TrendingBannerContainer = props => {
  const {
    trendingBannerObject,
    bannerContainerClassName,
    bannerSlotClassName,
    bannerImgClassName,
  } = props;
  if (trendingBannerObject && trendingBannerObject.length) {
    return (
      <GridRow className={bannerContainerClassName}>
        {trendingBannerObject.map(data => (
          <TrendingBannerComponent.component
            banner={data}
            bannerSlotClassName={bannerSlotClassName}
            bannerImgClassName={bannerImgClassName}
          />
        ))}
      </GridRow>
    );
  }
  return null;
};

TrendingBannerContainer.propTypes = {
  trendingBannerObject: PropTypes.arrayOf({
    brandId: PropTypes.string.isRequired,
    productListingUrl: PropTypes.string.isRequired,
    images: PropTypes.shape({
      logo: PropTypes.string.isRequired,
    }).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  bannerContainerClassName: PropTypes.string.isRequired,
  bannerImgClassName: PropTypes.string.isRequired,
  bannerSlotClassName: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: TrendingBannerContainer,
  component: TrendingBannerContainer,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/BrandsList/TrendingBannerContainer/index.js